// extracted by mini-css-extract-plugin
export var Layout = "layout-module--Layout--77fca";
export var slideIn = "layout-module--slide-in--12cc0";
export var slideInFromRight = "layout-module--slide-in-from-right--7078a";